import "./EditAgendaItemForm.scss";

import {
  agendaItemDecision,
  agendaItemDepartment,
  agendaItemFinalBoard,
  agendaItemGuests,
  agendaItemNote,
  agendaItemPerusal,
  agendaItemProtocolEntry,
  agendaItemProtocolEntryDraft,
  agendaItemTitle,
} from "ApiMaxLength";
import { HookFormInput } from "components/HookForm/HookFormInput";
import { HookFormRichText } from "components/HookForm/HookFormRichText";
import { HookFormSelect } from "components/HookForm/HookFormSelect";
import { HookFormToggle } from "components/HookForm/HookFormToggle";
import { InlineSpinner } from "components/InlineSpinner";
import { AgendaItemTypeEnum } from "enums/AgendaItemTypeEnum";
import { ResourceKeys, useAgendaItemStatuses, useAgendaItemTypes, useEditAgendaItem, useTranslations } from "providers";
import React from "react";

export const EditAgendaItemForm: React.FC = () => {
  const i18n = useTranslations();
  const { agendaItemStatuses } = useAgendaItemStatuses();
  const { agendaItemTypes } = useAgendaItemTypes();
  const { form, isLoading } = useEditAgendaItem();
  const { control } = form;

  if (isLoading) {
    return <InlineSpinner text={i18n.AgendaItems_Loading_EditForm} />;
  }

  if (!control) {
    return null;
  }

  const type = form.getValues("type");

  return (
    <>
      <HookFormRichText
        name="title"
        control={control}
        label={ResourceKeys.AgendaItem_Title_Title}
        contextHelp={ResourceKeys.AgendaItem_Title_Description}
        required
        maxLength={agendaItemTitle}
      />

      <HookFormInput
        name="duration"
        control={control}
        label={ResourceKeys.AgendaItem_Duration_Title}
        contextHelp={ResourceKeys.AgendaItem_Duration_Description}
      />

      <HookFormSelect
        name="status"
        control={control}
        label={ResourceKeys.AgendaItem_Status_Title}
        contextHelp={ResourceKeys.AgendaItem_Status_Description}
        options={agendaItemStatuses}
        required
      />

      <HookFormSelect
        name="type"
        control={control}
        label={ResourceKeys.AgendaItem_Type_Title}
        contextHelp={ResourceKeys.AgendaItem_Type_Description}
        options={agendaItemTypes}
        required
      />

      {type !== AgendaItemTypeEnum.Break && type !== AgendaItemTypeEnum.Category && (
        <>
          <HookFormToggle
            name="confidential"
            control={control}
            label={ResourceKeys.AgendaItem_Confidential_Title}
            contextHelp={ResourceKeys.AgendaItem_Confidential_Description}
          />

          <HookFormToggle
            name="locked"
            control={control}
            label={ResourceKeys.AgendaItem_Locked_Title}
            contextHelp={ResourceKeys.AgendaItem_Locked_Description}
          />

          <HookFormInput
            name="department"
            control={control}
            label={ResourceKeys.AgendaItem_Department_Title}
            contextHelp={ResourceKeys.AgendaItem_Department_Description}
            maxLength={agendaItemDepartment}
          />

          <HookFormRichText
            name="note"
            control={control}
            label={ResourceKeys.AgendaItem_Note_Title}
            contextHelp={ResourceKeys.AgendaItem_Note_Description}
            maxLength={agendaItemNote}
          />

          <HookFormRichText
            name="guests"
            control={control}
            label={ResourceKeys.AgendaItem_Guests_Title}
            contextHelp={ResourceKeys.AgendaItem_Guests_Description}
            maxLength={agendaItemGuests}
          />

          <HookFormInput
            name="finalBoard"
            control={control}
            label={ResourceKeys.AgendaItem_FinalBoard_Title}
            contextHelp={ResourceKeys.AgendaItem_FinalBoard_Description}
            maxLength={agendaItemFinalBoard}
          />

          <HookFormRichText
            name="decision"
            control={control}
            label={ResourceKeys.AgendaItem_Decision_Title}
            contextHelp={ResourceKeys.AgendaItem_Decision_Description}
            maxLength={agendaItemDecision}
          />

          <HookFormRichText
            name="perusal"
            control={control}
            label={ResourceKeys.AgendaItem_Perusal_Title}
            contextHelp={ResourceKeys.AgendaItem_Perusal_Description}
            maxLength={agendaItemPerusal}
          />

          <HookFormRichText
            name="protocolEntryDraft"
            control={control}
            label={ResourceKeys.AgendaItem_ProtocolEntryDraft_Title}
            contextHelp={ResourceKeys.AgendaItem_ProtocolEntryDraft_Description}
            maxLength={agendaItemProtocolEntryDraft}
          />

          <HookFormRichText
            name="protocolEntry"
            control={control}
            label={ResourceKeys.AgendaItem_ProtocolEntry_Title}
            contextHelp={ResourceKeys.AgendaItem_ProtocolEntry_Description}
            maxLength={agendaItemProtocolEntry}
          />
        </>
      )}
    </>
  );
};
